
      function onEventStub(name, listener) {
        const rows = onEventStub.q ?? []
        rows.push([name, listener])
        onEventStub.q = rows
      }

      window.RepairIntelligence = {
        getUserId: () => null,
        addItemsToCart: (items, caseId) => {
          console.log("addItemsToCart: ", items, caseId)
        },
        getPartPrices: async (items) => {
          console.log("getPartPrices:", items)
          // Return host-source price + stock status keyed by oem_number.
          return Object.fromEntries(
            items.map((item, index) => [
              item.oem_number,
              {
                price: 4999 + index,
                inventory_status: index % 2 === 0 ? "in_stock" : "out_of_stock",
              },
            ]),
          )
        },
        pageContext: null,
        setPageContext(ctx) {
          this.pageContext = ctx
          window.dispatchEvent(
            new CustomEvent("repairintelligence:pagecontext", {detail: ctx}),
          )
          window.dispatchEvent(
            new CustomEvent("ri2:pagecontext", {detail: ctx}),
          )
          // Update the active-label indicator in the test panel
          document
            .querySelectorAll("#repairintelligence-test-controls button")
            .forEach((b) => {
              b.style.fontWeight = "normal"
              b.style.background = "#fff"
            })
          const activeBtn = document.querySelector(
            `[data-ctx="${ctx?.pageType || "none"}"]`,
          )
          if (activeBtn) {
            activeBtn.style.fontWeight = "600"
            activeBtn.style.background = "#F0FDF4"
          }
        },
        navigateTo(path) {
          console.log("navigateTo:", path)
          window.open(path, "_blank")
        },
        getModelPageUrl(modelId) {
          return `/ProductDetail/${modelId}`
        },
        getPartDetailUrl({name, oemNumber, id}) {
          return `/PartDetail/${name}/${oemNumber}/${id}`
        },
        getRecommendationUrl({type, case: riCase}) {
          console.log("getRecommendationUrl:", {type, case: riCase})
          const brand = (riCase?.brand || "").trim().toLowerCase()
          const isGe = [
            "ge",
            "ge appliances",
            "general electric",
            "hotpoint",
            "cafe",
            "café",
            "profile",
            "monogram",
            "haier",
          ].includes(brand)

          switch (type) {
            case "diy":
              return null
            case "proService":
              if (!isGe) return null
              return "https://www.bodewell.com/service-areas"
            case "replace": {
              const term = riCase?.modelNumber || riCase?.brand || "test"
              return `https://www.bodewell.com/search-result-page?term=${encodeURIComponent(term)}`
            }
            default:
              return null
          }
        },
        getReplacementEstimate(context) {
          console.log("getReplacementEstimate:", context)
          const pricesByModel = {
            GTD58GBPV0DG: 749,
            CFE28UP2MMS1: 4031,
            HTW265ASW0WW: 554,
            GUD24GSSM0WW: 1549,
            JK3800SHASS: 2799,
          }
          const modelNumber = context?.case?.modelNumber
          const price = modelNumber && pricesByModel[modelNumber]
          if (!price) return null
          return {
            price,
            replaceUrl: "https://www.bodewell.com/search-result-page?term=test",
            disclosure:
              "Estimated retail price from the host catalog. Actual price may vary.",
            modelNumber: modelNumber || null,
          }
        },
        onEvent: onEventStub,
      }
      window.ri2 = window.RepairIntelligence

      onEventStub("intake_updated", (event) => {
        console.log("[host] intake_updated", event)
      })
      onEventStub("intake_completed", (event) => {
        console.log("[host] intake_completed", event)
      })
    